import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setRatingBroker, setRatingBrokers } from '@/redux/rating/ratingSlice';

import ratingService from '@/services/ratingService';

const getRatingBrokers = () => async dispatch => {
  try {
    const response = await ratingService.getRatingBrokers();
    const {
      data: { items },
    } = response;

    dispatch(setRatingBrokers(items));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetRatingBrokers failure',
    );
  }
};

const getRatingBroker = id => async dispatch => {
  try {
    const response = await ratingService.getRatingBroker(id);
    const { data } = response;

    dispatch(setRatingBroker(data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetRatingBroker failure',
    );
  }
};

export default {
  getRatingBrokers,
  getRatingBroker,
};
